<mat-toolbar class="p-0 mat-elevation-z1">
  <div class="fx-flex fx-row fx-justify-start fx-items-center fx-fill">
    <div class="fx-flex-1-0-auto fx-row fx-justify-start fx-items-center">
      @if (!hiddenNavbar) {
        <button mat-icon-button (click)="toggleSidebarOpen('navbar')" class="navbar-toggle-button fx-hide-gt-md">
          <mat-icon class="secondary-text">menu</mat-icon>
        </button>
      }
      <div class="logo logo-desktop">
        @if (selectedDomainId) {
          <img class="logo-icon" [src]='appService.getBaseServerAddressRoot() + "/domain/logo?domain_id="+selectedDomainId' alt=""/>
        }
      </div>
    </div>

    <div class="fx-flex-0-1-auto fx-row fx-justify-start fx-items-center">
      <!--<ng-container
      *ngFor="let buttonConfig of appService.toolbarPageActions"
      >
      <button
        mat-button
        class="toolbar-button accent"
        [ngClass]="buttonConfig.classes"
        (click)="buttonConfig.onClick()"
        >
        <span *ngIf="buttonConfig.title">{{
          buttonConfig.title
        }}</span>
        <mat-icon *ngIf="buttonConfig.icon">{{
          buttonConfig.icon
        }}</mat-icon>
      </button>
    </ng-container>-->
    <div class='pr-30 pl-30 instance-form filter_domain'>
      @if (domainFilterService.showFilterBar) {
        <form-input-viewer
          [formInputDefinition]='fileterFields.get("domain_id")'
          [formGroup]='filterFormGroup'
          formControlKey='domain_id'
        ></form-input-viewer>
      }
    </div>

    <div class="toolbar-separator filter_domain"></div>

    <div class="h3 mat-button current_date_time pr-30 pl-30">
      {{ dateNow | date: 'd MMMM y, HH:mm:ss' }}
    </div>

    <div class="toolbar-separator filter_domain_mobile"></div>

    @if (domainFilterService.showFilterBar) {
      <button (click)='filterDomainDialog()' mat-button class="filter_domain_mobile">
        <mat-icon>public</mat-icon>
      </button>
    }

    <div class="toolbar-separator"></div>

    @if (user) {
      <button mat-button [matMenuTriggerFor]="userMenu" class="user-button pr-30 pl-30">
        <div class="fx-row fx-justify-center fx-items-center">
          <img class="avatar mr-0 mr-sm-16" [src]='userImage' />
          <span class="username mr-12 fx-hide fx-show-gt-sm">{{user.name}}</span>
          <mat-icon class="s-16 fx-hide-xs">keyboard_arrow_down</mat-icon>
        </div>
      </button>
    }

    <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
      <!-- edit profile -->
      <button mat-menu-item class="" (click)="editProfile()">
        <mat-icon>person</mat-icon>
        <span>{{'Modifica Profilo' | translate}}</span>
      </button>
      <!-- edit password -->
      <button mat-menu-item class="" (click)="resetPassword()">
        <mat-icon>lock</mat-icon>
        <span>{{'Modifica Password' | translate}}</span>
      </button>
      @if (isAdministrator && domainFilterService.filterDomainId.value) {
        <button mat-menu-item [routerLink]="'/dataset/detail/domains/'+domainFilterService.filterDomainId.value">
          <mat-icon>settings</mat-icon>
          <span>{{'Impostazioni dominio' | translate}}</span>
        </button>
      }
      <!-- logout -->
      <button mat-menu-item class="" (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>{{'Logout' | translate}}</span>
      </button>
      <div class="px-16 py-8 h5 hint-text">{{'Versione' | translate}} {{buildVersion}}</div>
    </mat-menu>

    <!--<fuse-search-bar (input)="search($event)"></fuse-search-bar>-->

    <div class="toolbar-separator"></div>

    <button mat-button class="language-button pr-30 pl-30" [matMenuTriggerFor]="languageMenu">
      <div class="fx-row fx-justify-center fx-items-center">
        <img class="flag mr-8" [src]="'assets/icons/flags/'+selectedLanguage.flag+'.svg'">
        <span class="iso text-uppercase">{{selectedLanguage.id}}</span>
      </div>
    </button>

    <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
      @for (lang of languages; track lang) {
        <button mat-menu-item (click)="setLanguage(lang)">
          <span class="fx-row fx-justify-start fx-items-center">
            <img class="flag flag-menu mr-16" [src]="'assets/icons/flags/'+lang.flag+'.svg'">
            <span class="iso">{{lang.title}}</span>
          </span>
        </button>
      }
    </mat-menu>
    <!--
    <div class="toolbar-separator fx-hide fx-show-gt-xs"></div>

    <button mat-icon-button
      class="quick-panel-toggle-button"
      (click)="toggleSidebarOpen('quickPanel')"
      aria-label="Toggle quick panel">
      <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
    </button>

    <div *ngIf="!hiddenNavbar && rightNavbar" class="toolbar-separator fx-hide fx-show-gt-xs"></div>
    -->
    <!--
    <button mat-icon-button *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" class="navbar-toggle-button fx-hide-gt-md">
      <mat-icon class="secondary-text">menu</mat-icon>
    </button>
    -->
  </div>
</div>
</mat-toolbar>
